import React from "react";
import { useResponsiveStyles } from "../../../../styles/useResponsiveStyles";

export const RankDisplay = ({ rank }) => {
    const { getFontSize, getSectionStyle } = useResponsiveStyles();

    return (
        <div
            className="relative flex flex-col items-center justify-center bg-red-50 rounded-lg border-2 border-red-100"
            style={getSectionStyle("identity-card-image")}
        >
            <span
                className="text-[#ED1C24] font-bold"
                style={getFontSize("identity-card-name")}
            >
                Rank
            </span>
            <span
                className="font-bold text-[#ED1C24]"
                style={getFontSize("client-rank")}
            >
                {rank}
            </span>
        </div>
    );
};
